import { useState, useMemo } from "react";
import Tabs, { Tab } from "react-awesome-tabs";
import "react-awesome-tabs/dist/react-awesome-tabs.css";
import DataTable from "react-data-table-component";
import {
  disbursementColumns,
  exportDisbursementData,
  topLevelDisbursementColumns,
} from "../../utils/columns/disbursement";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { Button } from "react-bootstrap";
import { customStyles, formatNumber } from "../../utils/data/essential";
import Locations from "../../Component/Locations";
import moment from "moment";
import { CSVLink } from "react-csv";
const firstdate = moment().startOf("month").format("YYYY-MM-DD");
const today = moment().format("YYYY-MM-DD");
const statuses = [
  {
    id: 0,
    name: "INITIAL",
  },
  {
    id: 1,
    name: "READY",
  },
  {
    id: 2,
    name: "PENDING",
  },
  {
    id: 3,
    name: "COMPLETED",
  },
  {
    id: 4,
    name: "CANCELED",
  },
  {
    id: 5,
    name: "RETAINED",
  },
  {
    id: 14,
    name: "FAILED",
  },
  {
    id: 20,
    name: "SCHEDULED",
  },
];
const TopLevelDisbursement = () => {
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [disbursementData, setDisbursementData] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [toDate, setToDate] = useState(today);
    const [fromDate, setFromDate] = useState(firstdate);
  const extractData = (data) => {
    let obj = {};
    let arr = [];
    data?.forEach((el) => {
      obj.beneficiary = el.beneficiary?.name;
      obj.accountNumber = el.beneficiary?.disbursementAccount.accountNumber;
      obj.transferId = el?.transferId;
      obj.date = moment(el?.date).format("DD/MM/YYYY");
      obj.transferDate = moment(el.transfer?.datetime).format("DD/MM/YYYY");
      obj.totalNetAmount = formatNumber(el?.totalNetAmount);
      obj.totalAgentCommission = el?.totalAgentCommission;
      obj.totalOperatorCommission = formatNumber(el?.totalOperatorCommission);
      obj.totalPaidAmount = formatNumber(el?.totalPaidAmount);
      obj.adjustment = el.totalAdjustmentAmount;
      obj.status = el.status?.name;
      obj.province= el.location.province
      obj.district= el.location.district
      obj.sector= el.location.sector
      obj.cell = el.location.cell;
      arr.push(obj);
      obj = {};
    });
    setDisbursementData(arr.reverse());
  };
  const filterData = (searchTerm) => {
    if (!searchTerm) {
      return disbursementData.reverse();
    }
    return disbursementData
      ?.filter((dt) => {
        return (
          dt?.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
          dt?.province.toLowerCase().includes(searchTerm.toLowerCase()) ||
          dt?.district.toLowerCase().includes(searchTerm.toLowerCase()) ||
          dt?.sector.toLowerCase().includes(searchTerm.toLowerCase()) ||
          dt?.cell.toLowerCase().includes(searchTerm.toLowerCase())
        );
      })
      .reverse();
  };
  const filteredData = useMemo(
    () => filterData(keyword),
    [disbursementData, keyword]
  );
  const fetchDisbursement = async () => {
      setLoading(true);
      const disbursementResponse = await fetch(
        `${baseUrl}/beneficiaries/disbursements?from=${fromDate}&to=${toDate}`,
        {
          method: "GET",
          headers: new Headers({
            Authorization: "Bearer " + user.access_token,
            Accept: "application/json",
            "Content-Type": "application/json",
          }),
        }
      );
      if (!disbursementResponse.ok) {
        throw new Error("Failed to fetch subscriber data");
      }
      setLoading(false);
      const disbursementData = await disbursementResponse.json();
      extractData(disbursementData);
  };
  return (
    <div>
      <form className='d-flex justify-content-center pr-3 mt-3'>
        <div className='d-flex' style={{ height: 40 }}>
          <label className='mr-2 mt-2 ml-3'>From:</label>
          <input
            type='date'
            value={fromDate}
            className='mr-2 h-100 form-control input-select'
            onChange={(e) => {
              setFromDate(e.target.value);
            }}
          />
        </div>
        <div className='d-flex' style={{ height: 40 }}>
          <label className='mr-2 mt-2'>To:</label>
          <input
            type='date'
            className='mr-2 h-100 form-control input-select'
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
            }}
          />
        </div>
      </form>
      <div className='d-flex justify-content-center ml-5'>
        <Button
          onClick={() => {
            fetchDisbursement();
          }}
          className='custom-btn-color disbursement-btn'
        >
          {loading ? "Loading..." : "Search"}
        </Button>
      </div>
      <div className='d-flex flex-wrap justify-content-center'>
        {disbursementData?.length > 0 && (
          <div className='flex-container' style={{ width: "100%" }}>
            <div className='quick-search-container'>
              <input
                type='text'
                className='form-control quick-search ml-2'
                placeholder='Filter by location or status'
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                style={{
                  bottom: filteredData.length === 0 ? -50 : -80,
                }}
              />
            </div>
          </div>
        )}
      </div>
      {disbursementData?.length > 0 && (
        <div className='d-flex justify-content-end mr-3'>
          <CSVLink
            data={filteredData}
            headers={exportDisbursementData}
            filename={`disbursement_report`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={disbursementData.length === 0}
              style={{
                backgroundColor:
                  disbursementData.length === 0 ? "#cbcbcb" : "#124db1",
                color: disbursementData.length === 0 ? "#000" : "",
                cursor: disbursementData.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}
      <div
        className='table-responsive datatables dataValidation-Wrap'
        style={{ width: "100%" }}
      >
        <DataTable
          columns={topLevelDisbursementColumns}
          data={filteredData}
          defaultSortField='date' // Set the default sort field to the 'date' column
          defaultSortAsc={false} // Sort in descending order by default
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          numberiped
          noHeader
        />
      </div>
    </div>
  );
};
export default TopLevelDisbursement;
